import { create } from 'zustand';

type HarPresenceState = {
  presenceByThread: Record<string, ReadonlySet<string>>;
  markPresent: (threadId: string, toolCallId: string) => void;
  setThreadPresence: (threadId: string, toolCallIds: string[]) => void;
};

export const useHarPresenceStore = create<HarPresenceState>((set) => ({
  presenceByThread: {},
  markPresent: (threadId, toolCallId) =>
    set((state) => {
      const existing = state.presenceByThread[threadId];
      if (existing?.has(toolCallId)) {
        return state;
      }
      const next = new Set(existing ?? []);
      next.add(toolCallId);
      return {
        presenceByThread: { ...state.presenceByThread, [threadId]: next },
      };
    }),
  setThreadPresence: (threadId, toolCallIds) =>
    set((state) => {
      const existing = state.presenceByThread[threadId];
      const next = new Set(existing ?? []);
      let changed = false;
      for (const toolCallId of toolCallIds) {
        if (!next.has(toolCallId)) {
          next.add(toolCallId);
          changed = true;
        }
      }
      if (!changed && existing) {
        return state;
      }
      return {
        presenceByThread: { ...state.presenceByThread, [threadId]: next },
      };
    }),
}));
